import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { SvgIconModule } from 'shared/components/svg-icon/svg-icon.module';
import { InactiveWidgetFooterModule } from '../../shared/components/inactive-widget-footer/inactive-widget-footer.module';
import { GenesysEmailBoxComponent } from './genesys-email-box.component';
import { GenesysEmailViewerModule } from 'shared/components/genesys-email-viewer/genesys-email-viewer.module';
import { WorkWidgetControlPanelModule } from 'shared/components/work-widget-control-panel/work-widget-control-panel.module';
import { GenesysEmailOutgoingHeaderModule } from 'shared/components/genesys-email-outgoing-header/genesys-email-outgoing-header.module';
import { GenesysEditorModule } from 'shared/components/genesys-editor/genesys-editor.module';
import { GenesysEmailFooterComponent } from './genesys-email-footer/genesys-email-footer.component';
import { AlertBoxModule } from 'shared/components/alert-box/alert-box.module';
import { GenesysWrapupPanelModule } from 'shared/components/genesys-wrapup-panel/genesys-wrapup-panel.module';
import { WorkItemWidgetSharedModule } from 'components/work-item-lane-list/work-item-lane/work-item-widget/shared/work-item-widget-shared.module';
import { ngfModule } from 'angular-file';
import { GenesysEmailAttachmentsModule } from 'shared/components/genesys-email-attachments/genesys-email-attachments.module';
import { GenesysUserPermissionCheckModule } from 'shared/directives/genesys-user-permission-check';
import { GenesysTransferPanelModule } from 'shared/components/genesys-transfer-panel/genesys-transfer-panel.module';
import { AutoSaveModule } from 'common/auto-save/auto-save.module';
import { MoreActionsPanelModule } from '../../shared/components/more-actions-panel/more-actions-panel.module';
import { GenesysEmailComposeService } from './services/genesys-email-compose.service';
import { GenesysIsFooterModeActivePipe } from './pipes/genesys-is-footer-mode-active.pipe';
import { GenesysProactiveEmailComponent } from './genesys-proactive-email/genesys-proactive-email.component';
import { GenesysEmailWrapupPanelComponent } from './genesys-email-wrapup-panel/genesys-email-wrapup-panel.component';
import { GenesysEmailAttachmentButtonComponent } from './genesys-email-attachment-button/genesys-email-attachment-button.component';
import { GenesysEmailCloseConfirmationModalComponent } from './genesys-email-close-confirmation-modal/genesys-email-close-confirmation-modal.component';
import { GenesysEmailFooterControlPanelComponent } from './genesys-email-footer-control-panel/genesys-email-footer-control-panel.component';
import { GenesysEmailEditorComponent } from './genesys-email-editor/genesys-email-editor.component';
import { GenesysEmailActionButtonsComponent } from './genesys-email-action-buttons/genesys-email-action-buttons.component';

@NgModule({
  imports: [
    CommonModule,
    SvgIconModule,
    TranslateModule,
    GenesysEmailViewerModule,
    GenesysEditorModule,
    InactiveWidgetFooterModule,
    WorkWidgetControlPanelModule,
    AlertBoxModule,
    GenesysEmailOutgoingHeaderModule,
    WorkItemWidgetSharedModule,
    ngfModule,
    GenesysEmailAttachmentsModule,
    GenesysWrapupPanelModule,
    GenesysUserPermissionCheckModule,
    GenesysTransferPanelModule,
    AutoSaveModule,
    MoreActionsPanelModule
  ],
  declarations: [
    GenesysEmailBoxComponent,
    GenesysEmailFooterComponent,
    GenesysIsFooterModeActivePipe,
    GenesysProactiveEmailComponent,
    GenesysEmailWrapupPanelComponent,
    GenesysEmailAttachmentButtonComponent,
    GenesysEmailCloseConfirmationModalComponent,
    GenesysEmailFooterControlPanelComponent,
    GenesysEmailEditorComponent,
    GenesysEmailActionButtonsComponent
  ],
  providers: [GenesysEmailComposeService],
  exports: [GenesysEmailBoxComponent]
})
export class GenesysEmailBoxModule {}
